import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      marginTop: theme.spacing(3),
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
      alignSelf: 'flex-end',
      justifyContent: 'end',
    },

    submitButton: {
      padding: theme.spacing(1.5, 3),
    },

    errorMessage: {
      color: COLORS.error.default,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
    },
  }),
  { name: 'SubmitButton' }
);
